const isServer = typeof window === 'undefined';

export const isIE = () => {
  if (isServer) return false;

  const ua = navigator.userAgent;
  /* MSIE used to detect old browsers and Trident used to newer ones*/
  return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
};



// WEBPACK FOOTER //
// ./src/utils/browser.js